import React from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const InjectMassage = (props: any) => <FormattedMessage {...props} />

export default injectIntl(InjectMassage)

